import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M2.667 13.333q-.55 0-.942-.392A1.28 1.28 0 0 1 1.333 12V4q0-.55.392-.942.392-.39.942-.391h10.666q.55 0 .942.391.392.392.392.942v8q0 .55-.392.941a1.28 1.28 0 0 1-.942.392zM8 8.666l5.333-3.333V4L8 7.333 2.667 4v1.333z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "email-closed"}) } }